import styled from "styled-components";

export const Styles = styled.div`
    .pricing-page {
        .team-slider-area {
            padding: 220px 0 80px;

            @media (max-width: 767px) {
                padding: 190px 0 40px;
            }

            @media (max-width: 575px) {
                padding: 300px 0 40px;
            }
        }
    }
`;